import React from 'react';
import {useTranslation} from "react-i18next";

const NpiDisplayProgram = ({value}:{value:string|undefined}) => {
    const {t} = useTranslation();
    return <span>{value ? value : <i>{t("INTERNAL.CLIENT.COMMON.NO_PROGRAM")}</i>}</span>;
};

export default NpiDisplayProgram;